(function () {
  if (window.__cookingSurveyStatsInit) return;
  window.__cookingSurveyStatsInit = true;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function parseTarget(value) {
    var parsed = parseFloat(String(value).replace(/[^\d.-]/g, ''));
    return isNaN(parsed) ? 0 : parsed;
  }

  function formatValue(value, decimals) {
    if (decimals > 0) {
      return value.toFixed(decimals);
    }
    return String(Math.round(value));
  }

  function animateCounter(element) {
    if (element.dataset.counted === 'true') return;
    element.dataset.counted = 'true';

    var target = parseTarget(element.dataset.countTarget);
    var suffix = element.dataset.countSuffix || '';
    var duration = parseInt(element.dataset.countDuration, 10) || 1800;
    var decimals = parseInt(element.dataset.countDecimals, 10) || 0;
    var valueNode = element.querySelector('[data-count-value]');

    if (!valueNode) return;

    if (prefersReducedMotion || target === 0) {
      valueNode.textContent = formatValue(target, decimals);
      return;
    }

    var start = null;

    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = target * eased;
      valueNode.textContent = formatValue(current, decimals);

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        valueNode.textContent = formatValue(target, decimals);
      }
    }

    valueNode.textContent = formatValue(0, decimals);
    window.requestAnimationFrame(step);
  }

  function initSection(section) {
    var counters = section.querySelectorAll('[data-count-target]');
    if (!counters.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      counters.forEach(animateCounter);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          animateCounter(entry.target);
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.35, rootMargin: '0px 0px -5% 0px' }
    );

    counters.forEach(function (counter) {
      observer.observe(counter);
    });
  }

  function initAll() {
    document.querySelectorAll('.cooking-survey-stats').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.cooking-survey-stats');
    if (section) initSection(section);
  });
})();
